import { faSave } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button } from '@mantine/core'
import React, { ReactElement } from 'react'

import useTemplateEditor from '../useTemplateEditor'

type TemplateEditorButtonProps = {
  values: any
}

const TemplateEditorButton = (
  props: TemplateEditorButtonProps,
): ReactElement => {
  const { values } = props

  const { open } = useTemplateEditor()

  const onClick = (): void => {
    open(values)
  }

  return (
    <Button
      // variant="light"
      onClick={onClick}
      leftIcon={<FontAwesomeIcon icon={faSave} />}
    >
      {i18n.t('save_as_template', 'Als Vorlage speichern')}
    </Button>
  )
}

export default TemplateEditorButton
